<!-- 蒙版组件 -->
<template>
    <div class="c-mask" v-if="IsShowMask">
        <div class="common-mask-bg">
            <c-carousel @closeMask="closeMask"></c-carousel>
            <!-- <Icon type="md-close-circle" class="icon-close-btn" @click="closeMask"/> -->
        </div>
    </div>
</template>

<script>
    import CCarousel from '@/components/carousel/CCarousel.vue'

    export default {
        name: 'CMask',
        components: {
            CCarousel
        },
        props: {
            infoMsg: {
                type: String,
                default() {
                    return 'cmask'
                }
            }
        },
        data() {
            return {
                IsShowMask: false
            }
        },
        computed: {},
        mounted() {
            // let carouselStatus = window.sessionStorage.getItem('carouselStatus');
            // 为null时显示蒙版
            // this.IsShowMask = !carouselStatus ? true : false;
        },
        methods: {
            closeMask(data) {
                this.IsShowMask = data;
                window.sessionStorage.setItem('carouselStatus', 'closed');
                this.$emit("isRunText", data);
            }
        }
    }
</script>

<style scoped>
    .common-mask-bg {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 1000;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
    }
</style>